/**
 * @file コンポーネント：お知らせリスト スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledNewslist = styled.ol`
    max-height: 65px;
    min-height: 65px;  /* 追加：最低限の高さを65pxに固定 */
    padding: 8px 62px;
    overflow-y: auto;
    box-sizing: content-box;
    background-color: #dee2e6;

    ${mediaQuery.sp(`
        padding: 8px 8px;
    `)};

    ${mediaQuery.spWide(`
        padding: 8px 8px;
    `)};
`;

export const StyledNewslistAnchor = styled.a`
    display: flex;
    color: #000000;
`;

export const StyledNewslistDate = styled.time`
    width: 5.5em;
    margin-right: 15px;
`;

export const StyledNewslistItem = styled.li`
    display: flex;
    margin-bottom: 4px;
    color: #000000;
    font-size: 14px;
    line-height: 1.5;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const StyledNewslistMore = styled.button`
    width: 100%;
    padding: 0;
    border: none;
    color: #000000;
    background-color: transparent;

    &::before {
        margin-right: 15px;
        font-weight: bold;
        content: "\f078";
    }
`;

export const StyledNewslistTitle = styled.span``;
